export enum ECommentReaction {
  LIKE = 1,
  UNLIKE = 2
}

export enum ECommentTable {
  VIDEO = 'Video',
  CAMPAIGN_SUBMISSION = 'CampaignSubmission'
}
